import { StandardCarrier } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import { ProblemOrdersAnalyticsTotalsSchema } from "@redotech/redo-model/analytics/analytics";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getProblemOrdersAnalytics = {
  name: "getProblemOrdersAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    problemType: z.string(),
    carrier: z.union([z.literal("all"), createEnum(StandardCarrier)]),
  }),
  output: ProblemOrdersAnalyticsTotalsSchema,
};
